import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import couponReducer from './slices/couponSlice';
import couponTypeReducer from './slices/couponTypeSlice';
import customerReducer from './slices/customerSlice';
import historyReducer from './slices/historySlice';
import announcementReducer from './slices/announcementSlice';
import healthtronUserReducer from './slices/healthtronUserSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    coupon: couponReducer,
    couponType: couponTypeReducer,
    customer: customerReducer,
    history: historyReducer,
    announcement: announcementReducer,
    healthtronUser: healthtronUserReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
